import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { EguardShortcutsComponent } from './shortcuts.component';
import { SharedModule } from '../../modules/shared.module';

@NgModule({
    declarations: [
        EguardShortcutsComponent
    ],
    imports     : [
        SharedModule,
        RouterModule
    ],
    exports     : [
        EguardShortcutsComponent
    ]
})
export class EguardShortcutsModule
{
}



// WEBPACK FOOTER //
// ./src/app/core/components/shortcuts/shortcuts.module.ts